module.exports = __webpack_public_path__ + "img/pergola-over-door.afaea069.jpg";